import { Col, Icon, Layout, message, Row } from 'antd';
import React from 'react';
import { DashboardProps } from './ModernLayoutContainer';
import { MainMenu } from './Sider/MainMenu';
import Scrollbars from 'react-custom-scrollbars';
import { MenuHeaderLogo } from './Sider/MenuHeaderLogo';
import { useLocalStorage, useMeasure } from 'react-use';
// import ExpandableSupportButton from '../../../shares/expandable-support-button/ExpandaleSupportButton';
// import { DrawerSupport } from '../../../shares/send-ticket-caresoft/DrawerSupport';
import DrawerCommonError from '../../../shares/CommonError';
import { useSelector } from '../../../redux/store';
import { IState } from '../../../redux/reducer';
import Sticky from 'react-stickynode';
import PubSub from 'pubsub-js';
import './style.scss';
import Header from './Header';
import Footer from './Footer';
import AlertLicenseComponent from '@shares/common/alert/AlertLicenseComponent';

const { Sider, Content } = Layout;

interface IProps extends DashboardProps {
  toggleDrawerBookmark: any;
  renderBreadCrumbTop?: any;
}

const ModernLayout = (props: IProps) => {
  const [collapsed, setCollapsed] = useLocalStorage('pango-menu-collapse', false);

  const [ref, { width }] = useMeasure();
  // const [visibleSupport, setVisibleSupport] = React.useState(false);

  const commonError = useSelector((state: IState) => state.ui.commonError);

  const [heightInterfaceWrapper, setHeightInterfaceWrapper] = React.useState(100);
  const [menuOffsetBottom, setMenuOffsetBottom] = React.useState(120);

  return (
    <Layout style={{ minHeight: '100vh' }} id="dashboard-v3">
      <Sider
        style={{
          overflow: 'hidden',
          height: '100vh',
          position: 'fixed',
          left: 0,
          background: 'rgba(250, 250, 250, 1)',
          borderRight: '1px solid rgba(233, 233, 233, 1)',
          overflowX: 'hidden',
        }}
        theme="light"
        collapsedWidth={80}
        collapsible
        collapsed={collapsed}
        width={290}
        trigger={null}
      >
        <MenuHeaderLogo
          {...props}
          collapsed={collapsed}
          onCollapse={() => {
            setCollapsed(!collapsed);
            setHeightInterfaceWrapper(100);
            setMenuOffsetBottom(120);
          }}
        />
        <Scrollbars
          autoHide
          style={{
            height: window.innerHeight - menuOffsetBottom,
            marginTop: 0,
            overflowX: 'hidden',
          }}
          renderThumbHorizontal={() => <span></span>}
        >
          <div
            className="main-menu-v3 menu-sub__core"
            style={{
              padding: collapsed ? '0px' : '5px 15px 20px 15px',
            }}
          >
            <MainMenu
              uiSetting={props.uiSetting}
              location={props.location}
              commonActionFromDAL={props.commonActionFromDAL}
              commonActionFromDALV2={props.commonActionFromDALV2}
              selectedSubMenu={props.selectedSubMenu}
              selectedLeftNav={props.selectedLeftNav}
              collapsed={collapsed || false}
              open={() => {
                setCollapsed(false);
              }}
            />
          </div>
        </Scrollbars>
        <div>
          <Sticky
            bottomBoundary=".ant-layout-sider" // selector đến container
            top={0}
          >
            <div
              style={{
                height: 80,
                borderTop: '1px solid #e8e8e8',
              }}
              onClick={() => {
                if (!collapsed) {
                  if (heightInterfaceWrapper === 210) {
                    setHeightInterfaceWrapper(80);
                    setMenuOffsetBottom(120);
                  } else {
                    setHeightInterfaceWrapper(210);
                    setMenuOffsetBottom(120 + 100);
                  }
                } else {
                  setHeightInterfaceWrapper(210);
                  setMenuOffsetBottom(120 + 100);
                  setCollapsed(!collapsed);
                }
              }}
            >
              <div
                style={{
                  padding: collapsed ? '20px 30px 10px 30px' : '10px 30px 10px 25px',
                  cursor: 'pointer',
                }}
              >
                <Row
                  type="flex"
                  justify="space-between"
                  style={{
                    color: heightInterfaceWrapper === 210 ? 'var(--primary-color)' : '',
                  }}
                >
                  <Col
                    style={{
                      fontWeight: 'bold',
                      alignItems: 'center',
                      display: 'flex',
                    }}
                  >
                    <Icon
                      style={{ fontSize: 20 }}
                      component={() => {
                        return (
                          <svg
                            width="1em"
                            height="1em"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M15.6347 2.12433C15.9618 1.29189 17.1377 1.29189 17.4648 2.12433L17.8928 3.21354L18.9775 3.6429C19.8068 3.97121 19.8068 5.14713 18.9775 5.47544L17.8928 5.90481L17.4648 6.99401C17.1377 7.82645 15.9618 7.82646 15.6347 6.99402L15.2067 5.90481L14.122 5.47544C13.2927 5.14714 13.2927 3.97121 14.122 3.6429L15.2067 3.21354L15.6347 2.12433ZM16.5497 2.52989L16.9645 3.58533C17.0641 3.83891 17.2644 4.04027 17.5181 4.14073L18.5752 4.55917L17.5181 4.97762C17.2644 5.07808 17.0641 5.27943 16.9645 5.53301L16.5497 6.58845L16.135 5.53301C16.0354 5.27943 15.8351 5.07808 15.5813 4.97762L14.5243 4.55917L15.5813 4.14073C15.8351 4.04027 16.0354 3.83891 16.135 3.58533L16.5497 2.52989Z"
                              fill="currentColor"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M3.3142 3.3142C4.73313 1.89527 7.03366 1.89527 8.45259 3.3142L20.6858 15.5474C22.1047 16.9663 22.1047 19.2669 20.6858 20.6858C19.2669 22.1047 16.9663 22.1047 15.5474 20.6858L3.3142 8.45259C1.89527 7.03366 1.89527 4.73313 3.3142 3.3142ZM7.39193 4.37486C6.55879 3.54171 5.208 3.54171 4.37486 4.37486C3.54171 5.208 3.54171 6.55879 4.37486 7.39193L5.96114 8.97821L8.97821 5.96114L7.39193 4.37486ZM16.6081 19.6251L7.0218 10.0389L10.0389 7.0218L19.6251 16.6081C20.4583 17.4412 20.4583 18.792 19.6251 19.6251C18.792 20.4583 17.4412 20.4583 16.6081 19.6251Z"
                              fill="currentColor"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M21.332 8.94659C21.0049 8.11416 19.8289 8.11416 19.5018 8.94659L19.3473 9.33987L18.956 9.49475C18.1266 9.82306 18.1266 10.999 18.956 11.3273L19.3473 11.4822L19.5018 11.8755C19.8289 12.7079 21.0049 12.7079 21.332 11.8755L21.4865 11.4822L21.8778 11.3273C22.7071 10.999 22.7071 9.82306 21.8778 9.49475L21.4865 9.33987L21.332 8.94659ZM20.4169 9.35216L20.2756 9.71166C20.176 9.96524 19.9757 10.1666 19.7219 10.2671L19.3583 10.411L19.7219 10.555C19.9757 10.6555 20.176 10.8568 20.2756 11.1104L20.4169 11.4699L20.5582 11.1104C20.6578 10.8568 20.858 10.6555 21.1118 10.555L21.4755 10.411L21.1118 10.2671C20.858 10.1666 20.6578 9.96524 20.5582 9.71166L20.4169 9.35216Z"
                              fill="currentColor"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M4.66784 15.1243C4.99493 14.2919 6.17088 14.2919 6.49797 15.1243L6.65251 15.5176L7.04379 15.6725C7.87315 16.0008 7.87315 17.1767 7.04378 17.505L6.65251 17.6599L6.49797 18.0532C6.17088 18.8856 4.99493 18.8856 4.66784 18.0532L4.5133 17.6599L4.12203 17.505C3.29266 17.1767 3.29266 16.0008 4.12202 15.6725L4.5133 15.5176L4.66784 15.1243ZM5.44164 15.8894L5.5829 15.5299L5.72417 15.8894C5.82381 16.143 6.02407 16.3443 6.27785 16.4448L6.64154 16.5888L6.27785 16.7327C6.02407 16.8332 5.82381 17.0345 5.72417 17.2881L5.5829 17.6476L5.44164 17.2881C5.342 17.0345 5.14174 16.8332 4.88796 16.7327L4.52427 16.5888L4.88796 16.4448C5.14174 16.3443 5.342 16.143 5.44164 15.8894Z"
                              fill="currentColor"
                            />
                          </svg>
                        );
                      }}
                    />{' '}
                    {!collapsed ? <span className="ml7">Interface</span> : null}
                  </Col>
                  {collapsed ? null : (
                    <Col>
                      {heightInterfaceWrapper === 210 ? (
                        <Icon
                          component={() => {
                            return (
                              <svg
                                width="8"
                                height="5"
                                viewBox="0 0 8 5"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M6.34679 3.89821L4.02565 1.48251L1.69966 3.89832L1.69968 3.89833L1.69767 3.90034C1.6202 3.97781 1.51524 4.01816 1.40689 4.01816C1.17463 4.01816 0.993005 3.83853 0.993005 3.60692C0.993005 3.48672 1.04537 3.38914 1.11067 3.31658L1.11062 3.31653L1.11397 3.31304L3.71585 0.602957L3.71574 0.602858L3.72049 0.598324C3.79737 0.524959 3.89858 0.467129 4.02461 0.467129C4.14682 0.467129 4.25647 0.521827 4.33461 0.606926L6.9343 3.3147C7.00956 3.39053 7.05619 3.49073 7.05619 3.60692C7.05619 3.83852 6.87458 4.01816 6.64232 4.01816C6.53659 4.01816 6.43072 3.97792 6.35181 3.90319L6.3517 3.90331L6.34679 3.89821Z"
                                  fill="currentColor"
                                  stroke="currentColor"
                                  stroke-width="0.3"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            );
                          }}
                        />
                      ) : (
                        <Icon
                          component={() => {
                            return (
                              <svg
                                width="15"
                                height="14"
                                viewBox="0 0 15 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M3.5533 4.83785C3.32549 5.06565 3.32549 5.435 3.5533 5.6628L7.0533 9.1628C7.28111 9.39061 7.65045 9.39061 7.87826 9.1628L11.3783 5.6628C11.6061 5.435 11.6061 5.06565 11.3783 4.83785C11.1505 4.61004 10.7811 4.61004 10.5533 4.83785L7.46578 7.92537L4.37826 4.83785C4.15045 4.61004 3.78111 4.61004 3.5533 4.83785Z"
                                  fill="currentColor"
                                />
                              </svg>
                            );
                          }}
                        />
                      )}
                    </Col>
                  )}
                </Row>

                {heightInterfaceWrapper === 80 ? null : (
                  <Row gutter={[10, 20]} className="mt20 ml20" align="middle">
                    <Col
                      xs={24}
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        PubSub.publish('CHANGE_LAYOUT', 'v1');
                        message.info({
                          content: 'Switched to the standard interface',
                        });
                      }}
                    >
                      <span>Standard interface</span>
                    </Col>
                    <Col
                      xs={24}
                      style={{
                        color: 'var(--primary-color)',
                      }}
                    >
                      <span>Modern interface</span>
                    </Col>
                  </Row>
                )}
              </div>
            </div>
          </Sticky>
        </div>
      </Sider>
      <Content style={{ marginLeft: collapsed ? 80 : 290 }} id="content-wrapper-v3">
        <div ref={ref as any}></div>

        <Header
          width={width}
          {...props}
          renderBreadCrumbTop={() => {
            return props.renderBreadCrumbTop ? (
              <div className="inter-normal custom-breadcrumb">{props.renderBreadCrumbTop()}</div>
            ) : null;
          }}
        />
        <div className="pt76">
          <AlertLicenseComponent className="pl35 pr35 mb20" />
          {props.renderTitle ? props.renderTitle() : null}
        </div>
        <div style={{ padding: '10px 0px 60px 10px' }}>{props.children}</div>

        <DrawerCommonError
          visible={commonError ? true : false}
          onClose={() => {
            props.showCommonError(undefined);
          }}
        />

        <Layout.Footer style={{ borderTop: '1px solid #e9e9e9' }} className="inter-normal">
          <Footer />
        </Layout.Footer>
      </Content>
    </Layout>
  );
};

export default ModernLayout;

// <DrawerSupport
//   commonActionFromDALV2={props.commonActionFromDALV2}
//   visible={visibleSupport}
//   onClose={() => {
//     setVisibleSupport(false);
//   }}
// />
// <ExpandableSupportButton
//   openFormCaresoft={() => {
//     setVisibleSupport(true);
//   }}
// />
